import { createFileRoute } from '@tanstack/react-router';
import { FormBuilder } from '@/components/agents/form-builder';

export const Route = createFileRoute('/_dashboard/agents/create/form')({
  component: FormBuilderPage,
});

function FormBuilderPage() {
  return <FormBuilder />;
}
